import { getApiUrl } from '../utils/apiBase';

export const getApiBaseUrl = () => getApiUrl();
export const getDirectApiUrl = () => getApiUrl();
export const API_BASE_URL = getApiUrl();
